import * as angular from "angular";
import moment from "moment";

import { Int } from "infrastructure/types";
import { BoxAccidentBodyControllerBase, IDiscountListItem } from "../boxAccidentBodyControllerBase";
import { ShortTermAccidentInsuredPerson } from "./shortTermAccident.factory";

export class ShortTermAccidentController extends BoxAccidentBodyControllerBase {
    public ageTypesInsuredPersons: Array<{ ageType: string; ageTypeId: Int; }>;
    public ageTypeId: Int = 1;

    public $onInit() {
        super.$onInit();

        this.ageTypesInsuredPersons = [
            { ageType: "Старше 18 лет", ageTypeId: 1 },
            { ageType: "Младше 18 лет", ageTypeId: 2 },
        ];

        this.registrationDateConfig = {
            endDate: moment().format("YYYY-MM-DD"),
            startDate: moment().subtract(100, "years").format("YYYY-MM-DD"),
        };

        if (!this.Contract.ContractStatusId) {
            this.Contract.UnderwriterCoefficient = this.Repository.UnderwriterCoefficientRestriction.Collection[0].MinValue;
        }

        this.discountCollection = this.getDiscountCollection();
        this.defaultNumberOfInsuredPersons = this.Repository.InsuredPersonCountRestriction.Collection[0].MinValue;

        if (!angular.isArray(this.Contract.InsuredPersons)) {
            this.Contract.InsuedPersons = [];
        }

        if (angular.equals(this.Contract.InsuredPersons.length, 0)) {
            for (let i = 0; i < this.defaultNumberOfInsuredPersons; i++) {
                this.Contract.InsuredPersons.push(new ShortTermAccidentInsuredPerson());
            }
        }
    }

    public addPerson() {
        for (let i = 1; i <= this.personsNumber; i++) {
            const insuredPerson = new ShortTermAccidentInsuredPerson();

            const person = this.ageTypesInsuredPersons.find(item => item.ageTypeId === this.ageTypeId);

            if (!person) {
                return;
            }

            if (person.ageType === "Старше 18 лет") {
                insuredPerson.InsuredPersonBirthday = moment().subtract(30, "years").format("YYYY-MM-DD");
            } else {
                insuredPerson.InsuredPersonBirthday = moment().subtract(10, "years").format("YYYY-MM-DD");
            }

            this.Contract.InsuredPersons.push(insuredPerson);
        }

        if (!this.isDisableAddPerson()) {
            this.personsNumber = 1;
        }
        this.pageSharedData.Form.modified = true;
    }

    public insuredPersonIsInsuredChanged() {
        if (this.isInsuredPersonIsInsured()) {
            if (this.insuredWatcher) {
                this.insuredWatcher();
            }

            this.removeInsuredPerson(0);

            if (this.Contract.InsuredPersons.length === 0) {
                this.addPerson();
            }
        } else {
            if ((this.Contract.InsuredPersons.length > 0) && (this.Contract.InsuredPersons[0].Guid !== this.Contract.InsuredGuid)) {
                const insuredPerson = new ShortTermAccidentInsuredPerson();
                insuredPerson.Guid = this.Contract.InsuredGuid;

                if ((this.Contract.InsuredPersons.length === 1) && this.isEmptyPerson(this.Contract.InsuredPersons[0])) {
                    this.Contract.InsuredPersons = [insuredPerson];
                } else {
                    this.Contract.InsuredPersons.unshift(insuredPerson);
                }
            }

            this.watchForInsuredPerson();
        }
    }

    public getDiscountCollection(): IDiscountListItem[] {
        const collection = [];
        let labelDiscount = "";
        const fromValue = this.Repository.DiscountRestriction.Value[0].Value;
        const toValue = this.Repository.DiscountRestriction.Value[1].Value;

        for (let i = fromValue; i <= toValue; i++) {
            if (i > 0) {
                labelDiscount = `${i} %`;
            } else {
                labelDiscount = "Без скидки";
            }

            collection.push({ Id: i, Value: labelDiscount });
        }
        return collection;
    }
}
